import { Checkbox } from 'antd'
import styled from 'styled-components'

export const AntCheckbox = styled(Checkbox)`
  &:not(.ant-checkbox-wrapper-disabled) {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.color.main};
      border-color: ${({ theme }) => theme.color.main};
    }

    &:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.color.main};
    }

    .ant-checkbox-checked::after {
      border: 1px solid ${({ theme }) => theme.color.main};
    }
  }
`
